export default {"src":"/_next/static/media/sstLogo.6074e81e.svg","height":80,"width":71,"blurWidth":0,"blurHeight":0};